import { useSelector } from 'react-redux'
import { Notification } from '../../../../../../../../../common/notification'
import {
  KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS,
  VALUE_SCORE_ANALYSIS,
} from '../../../../../../../../../tool/dynamicReport/constant'
import { DistributionChart } from './distribution'
import { selectChartDistribution, selectChartTrendOfScore } from './store/slice'
import { TrendOfScoreChart } from './trendsOfScore'

export const BottomContent = ({ isDynamicReport, settingDynamic }) => {
  const dataChartTrend = useSelector(selectChartTrendOfScore)
  const dataIndustry = useSelector(selectChartDistribution('industry'))
  const dataRegion = useSelector(selectChartDistribution('region'))
  const dataYear = useSelector(selectChartDistribution('year'))
  const arrValueDynamic = isDynamicReport
    ? settingDynamic[KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS]
    : []

  const renderContent = (dynamic) => {
    if (dynamic) {
      return (
        <>
          <div className="mb2">
            <div>
              {!!dataChartTrend?.length ? (
                <TrendOfScoreChart
                  isDynamicReport={isDynamicReport}
                  settingDynamic={arrValueDynamic}
                  period={
                    isDynamicReport
                      ? settingDynamic[
                          KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TIME_PERIOD
                        ]
                      : ''
                  }
                />
              ) : (
                <Notification isDynamicReport />
              )}
            </div>
            <div>
              {!!dataIndustry?.length ||
              !!dataRegion?.length ||
              !!dataYear?.length ? (
                <DistributionChart
                  isDynamicReport={isDynamicReport}
                  type={
                    isDynamicReport
                      ? settingDynamic[
                          KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TYPE_DISTRIBUTION
                        ]
                      : ''
                  }
                />
              ) : (
                <Notification isDynamicReport />
              )}
            </div>
          </div>
        </>
      )
    }

    return (
      <>
        <div className="dFlex">
          <div
            className="w50"
            style={{ paddingRight: 18 }}
            id="CHART_SCORE_SCORE_PERFORMANCE"
          >
            {!!dataChartTrend?.length ? (
              <TrendOfScoreChart
                isDynamicReport={isDynamicReport}
                settingDynamic={arrValueDynamic}
                period={
                  isDynamicReport
                    ? settingDynamic[
                        KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TIME_PERIOD
                      ]
                    : ''
                }
              />
            ) : (
              <Notification />
            )}
          </div>
          <div
            className="w50"
            style={{ paddingLeft: 18 }}
            id="CHART_DISTRIBUTION_SCORE_PERFORMANCE"
          >
            {!!dataIndustry?.length ||
            !!dataRegion?.length ||
            !!dataYear?.length ? (
              <DistributionChart
                isDynamicReport={isDynamicReport}
                type={
                  isDynamicReport
                    ? settingDynamic[
                        KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TYPE_DISTRIBUTION
                      ]
                    : ''
                }
              />
            ) : (
              <Notification />
            )}
          </div>
        </div>
      </>
    )
  }

  if (isDynamicReport) {
    if (
      arrValueDynamic.includes(VALUE_SCORE_ANALYSIS.TREND_OF_SCORE) &&
      !arrValueDynamic.includes(VALUE_SCORE_ANALYSIS.DISTRIBUTION_CHART)
    ) {
      return (
        <TrendOfScoreChart
          isDynamicReport={isDynamicReport}
          settingDynamic={arrValueDynamic}
          period={
            isDynamicReport
              ? settingDynamic[KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TIME_PERIOD]
              : ''
          }
        />
      )
    }
    if (
      !arrValueDynamic.includes(VALUE_SCORE_ANALYSIS.TREND_OF_SCORE) &&
      arrValueDynamic.includes(VALUE_SCORE_ANALYSIS.DISTRIBUTION_CHART)
    ) {
      return (
        <DistributionChart
          isDynamicReport={isDynamicReport}
          type={
            isDynamicReport
              ? settingDynamic[
                  KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.TYPE_DISTRIBUTION
                ]
              : ''
          }
        />
      )
    }
    if (
      !arrValueDynamic.includes(VALUE_SCORE_ANALYSIS.TREND_OF_SCORE) &&
      !arrValueDynamic.includes(VALUE_SCORE_ANALYSIS.DISTRIBUTION_CHART)
    ) {
      return <></>
    }
    return renderContent(true)
  }

  return <>{renderContent()}</>
}
